import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import GroupTherapyImg from '../img/family.png'; // Image for Group Therapy

const Group_Therapy = () => {
    const cardData = [
        {
            id: 1,
            title: 'Emotional Support from Peers',
            text: 'One of the primary benefits of group therapy is the emotional support participants receive from their peers. Being in a group of individuals facing similar challenges allows people to feel less isolated, share experiences, and gain validation from others who truly understand their struggles.',
        },
        {
            id: 2,
            title: 'Learning from Shared Experiences',
            text: 'Group therapy offers the opportunity to learn from others. Participants can share coping strategies, insights, and advice, which can be beneficial in overcoming personal struggles. Many people find that hearing others’ stories can help them see their own challenges in a new light.',
        },
        {
            id: 3,
            title: 'Building Communication Skills',
            text: 'During group therapy, individuals work on their communication skills. This includes learning to express emotions, listen actively, and respond empathetically. Improving these skills can significantly enhance relationships and foster personal growth in both therapeutic and non-therapeutic settings.',
        },
        {
            id: 4,
            title: 'Sense of Belonging',
            text: 'Group therapy provides a safe, supportive space where individuals can form meaningful connections with others. The shared experience of being part of a therapeutic group often creates a strong sense of belonging and community, which can be crucial for those struggling with loneliness.',
        },
        {
            id: 5,
            title: 'Insight from Facilitators',
            text: 'In group therapy, trained therapists or facilitators provide professional insights and guidance. They help keep the group on track, provide therapeutic interventions, and offer expert advice tailored to the group’s needs. This guidance is crucial in ensuring the effectiveness of the group therapy process.',
        },
        {
            id: 6,
            title: 'Personal Growth and Accountability',
            text: 'Group therapy encourages individuals to take responsibility for their growth and progress. Participants often feel accountable to one another, which can increase motivation and commitment to change. The group dynamic helps both individual and collective growth.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Group Therapy for Mental Health | Emotional Support, Communication & Personal Growth</title>
                <meta name="description" content="Group therapy offers emotional support, learning from shared experiences, and personal growth in a supportive environment. Discover how group therapy can help you manage anxiety, depression, and more." />
                <meta name="keywords" content="Group Therapy, Mental Health Support, Emotional Support, Personal Growth, Communication Skills, Peer Support, Therapy" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Group Therapy for Mental Health | Emotional Support, Communication & Personal Growth" />
                <meta property="og:description" content="Discover the benefits of group therapy including emotional support, learning from others, and personal growth. Improve communication skills and gain insights from expert facilitators." />
                <meta property="og:image" content={GroupTherapyImg} />
                <meta property="og:url" content="https://yourwebsite.com/group-therapy" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={GroupTherapyImg} alt="Group Therapy" className='img-fluid h-100 w-100 rounded-md'/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Group Therapy</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Group therapy is a form of psychotherapy that involves one or more therapists working with a group of individuals simultaneously. It is a supportive environment where participants can share their experiences, gain insights, and receive emotional support from others facing similar challenges.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>In group therapy, people work together to improve their mental health by focusing on common issues such as anxiety, depression, relationship problems, or trauma. This form of therapy can provide invaluable social support, offer fresh perspectives, and promote personal growth in a collaborative setting.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className='fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Group_Therapy;
